export const LANGUAGES = [
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'tl', name: 'Tagalog', flag: '🇵🇭' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'ur', name: 'اردو', flag: '🇵🇰' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' }
];

export const buildServices = (t, autoCreditFormUrl) => ([
  {
    id: 'vendas-casas',
    title: t('services.categories.houses.title'),
    description: t('services.categories.houses.description'),
    icon: '🏠',
    subCategories: [
      { title: t('services.categories.houses.items.new.title'), description: t('services.categories.houses.items.new.description'), image: '/images/services/casas-novas.jpg' },
      { title: t('services.categories.houses.items.used.title'), description: t('services.categories.houses.items.used.description'), image: '/images/services/casas-usadas.jpg' },
      { title: t('services.categories.houses.items.freePlan.title'), description: t('services.categories.houses.items.freePlan.description'), image: '/images/services/construcao-free-plan.jpg' },
      { title: t('services.categories.houses.items.commerce.title'), description: t('services.categories.houses.items.commerce.description'), image: '/images/services/casa-comercio.jpg' },
      { title: t('services.categories.houses.items.garage.title'), description: t('services.categories.houses.items.garage.description'), image: '/images/services/garagem-fechada.webp' },
      { title: t('services.categories.houses.items.warehouse.title'), description: t('services.categories.houses.items.warehouse.description'), image: '/images/services/galpao-medio.jfif' },
      { title: t('services.categories.houses.items.gourmet.title'), description: t('services.categories.houses.items.gourmet.description'), image: '/images/services/espaco-gourmet.jfif' },
      { title: t('services.categories.houses.items.fence.title'), description: t('services.categories.houses.items.fence.description'), image: '/images/services/cerca-gramado.jfif' },
      { title: t('services.categories.houses.items.internal.title'), description: t('services.categories.houses.items.internal.description'), image: '/images/services/reformas-internas.jpg' }
    ]
  },
  {
    id: 'seguros',
    title: t('services.categories.insurance.title'),
    description: t('services.categories.insurance.description'),
    icon: '🛡️',
    subCategories: [
      { title: t('services.categories.insurance.items.life.title'), description: t('services.categories.insurance.items.life.description'), image: '/images/services/seguro-vida-novo.jpg' },
      { title: t('services.categories.insurance.items.fire.title'), description: t('services.categories.insurance.items.fire.description'), image: '/images/services/seguro-incendio-novo.jpg' },
      { title: t('services.categories.insurance.items.auto.title'), description: t('services.categories.insurance.items.auto.description'), image: '/images/services/seguro-automovel-novo.jpg' },
      { title: t('services.categories.insurance.items.retirement.title'), description: t('services.categories.insurance.items.retirement.description'), image: '/images/services/seguro-aposentadoria.jpg' },
      { title: t('services.categories.insurance.items.business.title'), description: t('services.categories.insurance.items.business.description'), image: '/images/services/seguro-empresarial-novo.jpg' }
    ]
  },
  {
    id: 'placa-solar',
    title: t('services.categories.solar.title'),
    description: t('services.categories.solar.description'),
    icon: '☀️',
    subCategories: [
      { title: t('services.categories.solar.items.residential.title'), description: t('services.categories.solar.items.residential.description'), image: '/images/services/placa-solar-residencial.jpg' },
      { title: t('services.categories.solar.items.business.title'), description: t('services.categories.solar.items.business.description'), image: '/images/services/placa-solar-empresarial.jpg' }
    ]
  },
  {
    id: 'vendas-carros',
    title: t('services.categories.cars.title'),
    description: t('services.categories.cars.description'),
    icon: '🚗',
    subCategories: [
      { title: t('services.categories.cars.items.new.title'), description: t('services.categories.cars.items.new.description'), image: '/images/services/carro-novo.jpg' },
      { title: t('services.categories.cars.items.used.title'), description: t('services.categories.cars.items.used.description'), image: '/images/services/carro-usado.jpg' },
      { title: t('services.categories.cars.items.imported.title'), description: t('services.categories.cars.items.imported.description'), image: '/images/services/importado.jpg' },
      { title: t('services.categories.cars.items.parts.title'), description: t('services.categories.cars.items.parts.description'), image: '/images/services/pecas-acessorios.jpg' },
      { title: t('services.categories.cars.items.maintenance.title'), description: t('services.categories.cars.items.maintenance.description'), image: '/images/services/manutencao.jpg' }
    ]
  },
  {
    id: 'reforma',
    title: t('services.categories.renovation.title'),
    description: t('services.categories.renovation.description'),
    icon: '🏗️',
    subCategories: [
      { title: t('services.categories.renovation.items.renovation.title'), description: t('services.categories.renovation.items.renovation.description'), image: '/images/services/reforma.jpg' },
      { title: t('services.categories.renovation.items.design.title'), description: t('services.categories.renovation.items.design.description'), image: '/images/services/design-interiores.jpg' },
      { title: t('services.categories.renovation.items.consult.title'), description: t('services.categories.renovation.items.consult.description'), image: '/images/services/consultoria.jpg' }
    ]
  },
  {
    id: 'carros-reboque',
    title: t('services.categories.towing.title'),
    description: t('services.categories.towing.description'),
    icon: '🚛',
    subCategories: [
      { title: t('services.categories.towing.items.service.title'), description: t('services.categories.towing.items.service.description'), image: '/images/services/guincho-novo.jpg' }
    ]
  },
  {
    id: 'financiamento',
    title: 'Análise de Crédito Auto',
    description: 'Faça sua análise de crédito auto e siga direto para o formulário online.',
    icon: '🚗',
    externalLink: autoCreditFormUrl,
    subCategories: [
      { title: 'Análise de Crédito Auto', description: 'Clique para abrir o formulário e iniciar sua análise de crédito auto.', image: '/images/services/financiamento.jpg' }
    ]
  }
]);

export const buildTeamMembers = (t) => ([
  { name: t('team.members.roberto.name'), role: t('team.members.roberto.role'), image: '/images/team/roberto-novo.jpg' },
  { name: t('team.members.sumiko.name'), role: t('team.members.sumiko.role'), image: '/images/team/sumiko.jpg' }
]);

export const CLIENTS = [
  { name: 'TERADA', image: '/images/clients/terada.jpg' },
  { name: 'TAYO', image: '/images/clients/tayo.jpg' },
  { name: 'JESSY', image: '/images/clients/jessy.jpg' },
  { name: 'TAKEO', image: '/images/clients/takeo-novo.jpg' },
  { name: 'TAKASHI', image: '/images/clients/takashi-novo.jpg' },
  { name: 'AKIRA', image: '/images/clients/akira-novo.jpg' },
  { name: 'ANA', image: '/images/clients/ana-novo.jpg' },
  { name: 'AME', image: '/images/clients/ame.jpg' },
  { name: 'BANDO', image: '/images/clients/bando.jpg' },
  { name: 'BRU', image: '/images/clients/bru.jpg' },
  { name: 'CLELIA', image: '/images/clients/clelia.jpg' },
  { name: 'EDUARDO', image: '/images/clients/eduardo.jpg' },
  { name: 'FABIO', image: '/images/clients/fabio.jpg' },
  { name: 'FERNANDO', image: '/images/clients/fernando.jpg' },
  { name: 'FUJITO', image: '/images/clients/fujito.jpg' },
  { name: 'GLORIA', image: '/images/clients/gloria.jpg' },
  { name: 'HARUNO', image: '/images/clients/haruno.jpg' },
  { name: 'LUGO', image: '/images/clients/lugo.jpg' },
  { name: 'MAGALY', image: '/images/clients/magaly.jpg' },
  { name: 'MARCELO', image: '/images/clients/marcelo.jpg' },
  { name: 'MARLUCE', image: '/images/clients/marluce.jpg' },
  { name: 'NELSON', image: '/images/clients/nelson.jpg' },
  { name: 'SHIMIZU', image: '/images/clients/shimizu.jpg' },
  { name: 'XAVIER', image: '/images/clients/xavier.jpg' },
  { name: 'YANU', image: '/images/clients/yanu.jpg' }
];
